// src/context/ErrorContext.js

import React, { createContext, useCallback, useEffect, useMemo, useRef, useState } from 'react';

export const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const [errorType, setErrorType] = useState('error');
  const timeoutRef = useRef(null);

  const showPopup = useCallback((value, type = 'error') => {
    const message = value?.response?.data?.message || value?.userMessage || value?.errorMessage || value?.message || value || 'An unknown error occurred';
    setError(message);
    setErrorType(type);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setError(null);
      setErrorType('error');
      timeoutRef.current = null;
    }, 2500);
  }, []);

  const showError = useCallback((value) => {
    showPopup(value, 'error');
  }, [showPopup]);

  const showInfo = useCallback((value) => {
    const message = String(value || '').trim();
    if (!message) {
      return;
    }
    showPopup(message, 'info');
  }, [showPopup]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const value = useMemo(() => ({
    error,
    errorType,
    showError,
    showInfo
  }), [error, errorType, showError, showInfo]);

  return (
    <ErrorContext.Provider value={value}>
      {children}
    </ErrorContext.Provider>
  );
};
